module.exports = __webpack_public_path__ + "static/media/discoverLogo.536d4c19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/patient-list/images/discoverLogo.svg
// module id = 13717
// module chunks = 0